import React, { useState, useCallback, useContext } from "react";

import AvailabilityTable from "components/PageDashboard/AvailabilitySection/AvailabilityTable";
import { useRemoteResource } from "hooks/useRemoteResource";
import { useSendData } from "hooks/useSendData";
import { SearchResults } from "types-and-validators/SearchResults";
import { saveMentorAvailabilityPeriods } from "api/saveMentorAvailabilityPeriods";
import {
	getAvailability,
	OutputRow as AvailabilityData
} from "api/getAvailability";
import { AuthContext } from "components/AuthProvider/AuthProvider";
import { useOnEditEditableTable } from "hooks/useOnEditEditableTable";

const AvailabilitySection: React.FunctionComponent = () => {
	const [{ isSignedIn, uid }] = useContext(AuthContext);

	const fetchAvailability = useCallback(() => {
		if (!uid) {
			throw new Error("No uid");
		}
		return getAvailability(
			{
				uid
			},
			{ uid }
		);
	}, [uid]);

	const doWait = isSignedIn === undefined || !uid;

	const [fetchIterationNumber, setFetchIterationNumber] = useState(1);

	const {
		isWaiting,
		isLoading,
		isError,
		output: periodsOfAvailability
	} = useRemoteResource<SearchResults<AvailabilityData>>(
		fetchAvailability,
		doWait,
		fetchIterationNumber,
		true
	);

	const [waitModalIsShowing, setWaitModalIsShowing] = useState(false);
	const [waitModalTitle, setWaitModalTitle] = useState("");

	const doSaveAvailabilityPeriods = useSendData({
		method: saveMentorAvailabilityPeriods
	});

	const onEditAvailability = useOnEditEditableTable({
		setWaitModalIsShowing,
		setWaitModalTitle,
		dataSaver: doSaveAvailabilityPeriods,
		onSaved: setFetchIterationNumber
	});

	const dataForTable = periodsOfAvailability ? periodsOfAvailability.page : [];

	return (
		<AvailabilityTable
			onEdit={onEditAvailability}
			periodsOfAvailability={dataForTable}
			isLoading={isLoading}
			isWaiting={isWaiting || !periodsOfAvailability}
			isError={isError}
			waitModalTitle={waitModalTitle}
			waitModalIsShowing={waitModalIsShowing}
		/>
	);
};

export default AvailabilitySection;
